module.exports = __webpack_public_path__ + "static/img/06.cc03f95.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity/activity2024111/06.png
// module id = mxSZ
// module chunks = 0